export function buildAutoCompleteLabels(t) {
    return {
        clearLabel: t("common.clear", {}),
        resultsCountLabel: (count) => t("common.resultsCountPlural", count),
        emptyLabel: t("common.noResults", {}),
    };
}
